export const slugsPart1 = {
    ".ENV": "dotenv",
    ".NET": "dotnet",
    "/e/": "e",
    "1.1.1.1": "1dot1dot1dot1",
    "1&1": "1and1",
    "1001Tracklists": "1001tracklists",
    "1Panel": "1panel",
    "1Password": "1password",
    "2FAS": "2fas",
    "2K": "2k",
    "30 seconds of code": "30secondsofcode",
    "365 Data Science": "365datascience",
    "3M": "3m",
    "42": "42",
    "4chan": "4chan",
    "4D": "4d",
    "500px": "500px",
    "7Zip": "7zip",
    "99designs": "99designs",
    "9GAG": "9gag",
    "A-Frame": "aframe",
    "AB Download Manager": "abdownloadmanager",
    "ABB": "abb",
    "Abbott": "abbott",
    "Abbvie": "abbvie",
    "about.me": "aboutdotme",
    "Abstract": "abstract",
    "abuse.ch": "abusedotch",
    "Academia": "academia",
    "Accenture": "accenture",
    "Accusoft": "accusoft",
    "AccuWeather": "accuweather",
    "Acer": "acer",
    "ACM": "acm",
    "Acode": "acode",
    "ActiGraph": "actigraph",
    "Activeloop": "activeloop",
    "Activision": "activision",
    "ActivityPub": "activitypub",
    "Actix": "actix",
    "Actual Budget": "actualbudget",
    "Acura": "acura",
    "Ada": "ada",
    "Adafruit": "adafruit",
    "AdAway": "adaway",
    "AdBlock": "adblock",
    "Adblock Plus": "adblockplus",
    "addy.io": "addydotio",
    "AdGuard": "adguard",
    "Adidas": "adidas",
    "Adminer": "adminer",
    "AdonisJS": "adonisjs",
    "ADP": "adp",
    "Adroll": "adroll",
    "Advent Of Code": "adventofcode",
    "Adyen": "adyen",
    "Aegis Authenticator": "aegisauthenticator",
    "Aeroflot": "aeroflot",
    "Aeroméxico": "aeromexico",
    "AFDIAN": "afdian",
    "AFFiNE": "affine",
    "Afterpay": "afterpay",
    "AfterShip": "aftership",
    "Agora": "agora",
    "AI Dungeon": "aidungeon",
    "AIB": "aib",
    "AIOHTTP": "aiohttp",
    "Aiqfome": "aiqfome",
    "Air Canada": "aircanada",
    "Air China": "airchina",
    "Air France": "airfrance",
    "Air India": "airindia",
    "Air Serbia": "airserbia",
    "Air Transat": "airtransat",
    "AirAsia": "airasia",
    "Airbnb": "airbnb",
    "Airbrake": "airbrake",
    "Airbus": "airbus",
    "Airbyte": "airbyte",
    "Aircall": "aircall",
    "AirPlay Audio": "airplayaudio",
    "AirPlay Video": "airplayvideo",
    "Airtable": "airtable",
    "Airtel": "airtel",
    "Ajv": "ajv",
    "Akamai": "akamai",
    "Akasa Air": "akasaair",
    "Akaunting": "akaunting",
    "Akiflow": "akiflow",
    "Alacritty": "alacritty",
    "Alamy": "alamy",
    "Albert Heijn": "albertheijn",
    "Alby": "alby",
    "Alchemy": "alchemy",
    "Aldi Nord": "aldinord",
    "Aldi Süd": "aldisud",
    "Alfred": "alfred",
    "Algolia": "algolia",
    "Algorand": "algorand",
    "Alibaba Cloud": "alibabacloud",
    "Alibaba.com": "alibabadotcom",
    "Alienware": "alienware",
    "AliExpress": "aliexpress",
    "Alipay": "alipay",
    "AList": "alist",
    "Allegro": "allegro",
    "AlliedModders": "alliedmodders",
    "AllTrails": "alltrails",
    "AlmaLinux": "almalinux",
    "Alpine Linux": "alpinelinux",
    "Alpine.js": "alpinedotjs",
    "AlternativeTo": "alternativeto",
    "Alwaysdata": "alwaysdata",
    "AMD": "amd",
    "Ameba": "ameba",
    "American Airlines": "americanairlines",
    "American Express": "americanexpress",
    "AMG": "amg",
    "AMP": "amp",
    "Amul": "amul",
    "ANA": "ana",
    "Anaconda": "anaconda",
    "Analogue": "analogue",
    "Andela": "andela",
    "Android": "android",
    "Android Auto": "androidauto",
    "Android Studio": "androidstudio",
    "Angular": "angular",
    "AniChart": "anichart",
    "AniList": "anilist",
    "Animal Planet": "animalplanet",
    "Anime.js": "animedotjs",
    "AnkerMake": "ankermake",
    "Anki": "anki",
    "Ansible": "ansible",
    "Answer": "answer",
    "Ansys": "ansys",
    "Ant Design": "antdesign",
    "Anta": "anta",
    "Antena 3": "antena3",
    "AntennaPod": "antennapod",
    "Anthropic": "anthropic",
    "AntV": "antv",
    "Anycubic": "anycubic",
    "AnyDesk": "anydesk",
    "Anytype": "anytype",
    "Apache": "apache",
    "Apache Airflow": "apacheairflow",
    "Apache Ant": "apacheant",
    "Apache Avro": "apacheavro",
    "Apache Cassandra": "apachecassandra",
    "Apache CloudStack": "apachecloudstack",
    "Apache Cordova": "apachecordova",
    "Apache CouchDB": "apachecouchdb",
    "Apache DolphinScheduler": "apachedolphinscheduler",
    "Apache Doris": "apachedoris",
    "Apache Druid": "apachedruid",
    "Apache ECharts": "apacheecharts",
    "Apache Flink": "apacheflink",
    "Apache FreeMarker": "apachefreemarker",
    "Apache Groovy": "apachegroovy",
    "Apache Guacamole": "apacheguacamole",
    "Apache Hadoop": "apachehadoop",
    "Apache HBase": "apachehbase",
    "Apache Hive": "apachehive",
    "Apache JMeter": "apachejmeter",
    "Apache Kafka": "apachekafka",
    "Apache Kylin": "apachekylin",
    "Apache Lucene": "apachelucene",
    "Apache Maven": "apachemaven",
    "Apache NetBeans IDE": "apachenetbeanside",
    "Apache NiFi": "apachenifi",
    "Apache OpenOffice": "apacheopenoffice",
    "Apache Parquet": "apacheparquet",
    "Apache PDFBox": "apachepdfbox",
    "Apache Pulsar": "apachepulsar",
    "Apache RocketMQ": "apacherocketmq",
    "Apache Solr": "apachesolr",
    "Apache Spark": "apachespark",
    "Apache Storm": "apachestorm",
    "Apache Superset": "apachesuperset",
    "Apache Tomcat": "apachetomcat",
    "Aparat": "aparat",
    "Apifox": "apifox",
    "APM Terminals": "apmterminals",
    "Apollo GraphQL": "apollographql",
    "Apostrophe": "apostrophe",
    "App Store": "appstore",
    "AppGallery": "appgallery",
    "Appian": "appian",
    "AppImage": "appimage",
    "Appium": "appium",
    "Apple": "apple",
    "Apple Arcade": "applearcade",
    "Apple Music": "applemusic",
    "Apple News": "applenews",
    "Apple Pay": "applepay",
    "Apple Podcasts": "applepodcasts",
    "Apple TV": "appletv",
    "AppManager": "appmanager",
    "AppSignal": "appsignal",
    "Appsmith": "appsmith",
    "AppVeyor": "appveyor",
    "Appwrite": "appwrite",
    "Aqua": "aqua",
    "ARAL": "aral",
    "ArangoDB": "arangodb",
    "Arc": "arc",
    "ArcGIS": "arcgis",
    "Arch Linux": "archlinux",
    "Archicad": "archicad",
    "Archive of Our Own": "archiveofourown",
    "Ardour": "ardour",
    "Arduino": "arduino",
    "Argo": "argo",
    "Argos": "argos",
    "Ariakit": "ariakit",
    "ARK Ecosystem": "arkecosystem",
    "Arlo": "arlo",
    "Arm": "arm",
    "Arm Keil": "armkeil",
    "Ars Technica": "arstechnica",
    "Artifact Hub": "artifacthub",
    "Artix Linux": "artixlinux",
    "ArtStation": "artstation",
    "arXiv": "arxiv",
    "Asahi Linux": "asahilinux",
    "Asana": "asana",
    "Asciidoctor": "asciidoctor",
    "asciinema": "asciinema",
    "ASDA": "asda",
    "Aseprite": "aseprite",
    "AssemblyScript": "assemblyscript",
    "Asterisk": "asterisk",
    "Aston Martin": "astonmartin",
    "Astra": "astra",
    "Astral": "astral",
    "Astro": "astro",
    "ASUS": "asus",
    "AT&T": "atandt",
    "Atari": "atari",
    "AtlasOS": "atlasos",
    "Atlassian": "atlassian",
    "Auchan": "auchan",
    "Audacity": "audacity",
    "Audi": "audi",
    "Audible": "audible",
    "Audio-Technica": "audiotechnica",
    "Audiobookshelf": "audiobookshelf",
    "Audioboom": "audioboom",
    "Audiomack": "audiomack",
    "Aurelia": "aurelia",
    "Autentique": "autentique",
    "Auth0": "auth0",
    "Authelia": "authelia",
    "Authentik": "authentik",
    "AutoCAD": "autocad",
    "AutoCannon": "autocannon",
    "Autodesk": "autodesk",
    "Autodesk Maya": "autodeskmaya",
    "Autodesk Revit": "autodeskrevit",
    "AutoHotkey": "autohotkey",
    "AutoIt": "autoit",
    "Automattic": "automattic",
    "Autoprefixer": "autoprefixer",
    "AutoZone": "autozone",
    "avajs": "avajs",
    "AvaloniaUI": "avaloniaui",
    "Avast": "avast",
    "avianca": "avianca",
    "Avira": "avira",
    "AVM": "avm",
    "Awesome Lists": "awesomelists",
    "awesomeWM": "awesomewm",
    "Awwwards": "awwwards",
    "Axios": "axios",
    "Axis Bank": "axisbank",
    "B&R Automation": "bandrautomation",
    "B4X": "b4x",
    "Babel": "babel",
    "Babelio": "babelio",
    "Babylon.js": "babylondotjs",
    "Backblaze": "backblaze",
    "Backbone": "backbone",
    "Backbone.js": "backbonedotjs",
    "Backendless": "backendless",
    "Backstage": "backstage",
    "Backstage (Casting)": "backstage_casting",
    "Badoo": "badoo",
    "Baidu": "baidu",
    "Bakaláři": "bakalari",
    "Bamboo": "bamboo",
    "Bambu Lab": "bambulab",
    "Bandcamp": "bandcamp",
    "BandLab": "bandlab",
    "Bandsintown": "bandsintown",
    "Bank of America": "bankofamerica",
    "Barclays": "barclays",
    "Baremetrics": "baremetrics",
    "Barmenia": "barmenia",
    "Basecamp": "basecamp",
    "Baserow": "baserow",
    "Basic Attention Token": "basicattentiontoken",
    "Bastyon": "bastyon",
    "bat": "bat",
    "Bata": "bata",
    "Battle.net": "battledotnet",
    "Bazel": "bazel",
    "Beatport": "beatport",
    "Beats": "beats",
    "Beats by Dre": "beatsbydre",
    "BeatStars": "beatstars",
    "Beekeeper Studio": "beekeeperstudio",
    "Behance": "behance",
    "Beijing Subway": "beijingsubway",
    "BEM": "bem",
    "Bentley": "bentley",
    "Bento": "bento",
    "BentoBox": "bentobox",
    "BentoML": "bentoml",
    "BeReal": "bereal",
    "Betfair": "betfair",
    "Better Auth": "betterauth",
    "Better Stack": "betterstack",
    "BetterDiscord": "betterdiscord",
    "Bevy": "bevy",
    "Big Cartel": "bigcartel",
    "bigbasket": "bigbasket",
    "BigBlueButton": "bigbluebutton",
    "BigCommerce": "bigcommerce",
    "Bilibili": "bilibili",
    "Billboard": "billboard",
    "BIM": "bim",
    "Binance": "binance",
    "Bio Link": "biolink",
    "Bioconductor": "bioconductor",
    "Biome": "biome",
    "BisectHosting": "bisecthosting",
    "Bit": "bit",
    "Bitbucket": "bitbucket",
    "Bitcoin": "bitcoin",
    "Bitcoin Cash": "bitcoincash",
    "Bitcoin SV": "bitcoinsv",
    "BitComet": "bitcomet",
    "Bitdefender": "bitdefender",
    "Bitly": "bitly",
    "Bitrise": "bitrise",
    "Bitsy": "bitsy",
    "BitTorrent": "bittorrent",
    "Bitwarden": "bitwarden",
    "Bitwig": "bitwig",
    "Black": "black",
    "Blackberry": "blackberry",
    "Blackmagic Design": "blackmagicdesign",
    "Blazemeter": "blazemeter",
    "Blazor": "blazor",
    "Blender": "blender",
    "Blibli": "blibli",
    "Blockbench": "blockbench",
    "Blockchain.com": "blockchaindotcom",
    "Blogger": "blogger",
    "Bloglovin": "bloglovin",
    "Blueprint": "blueprint",
    "Bluesky": "bluesky",
    "Bluesound": "bluesound",
    "Bluetooth": "bluetooth",
    "BMC Software": "bmcsoftware",
    "BMW": "bmw",
    "BNB Chain": "bnbchain",
    "BoardGameGeek": "boardgamegeek",
    "boAt": "boat",
    "Boehringer Ingelheim": "boehringeringelheim",
    "Boeing": "boeing",
    "Bohemia Interactive": "bohemiainteractive",
    "Bombardier": "bombardier",
    "Bookalope": "bookalope",
    "BookBub": "bookbub",
    "Booking.com": "bookingdotcom",
    "Bookmeter": "bookmeter",
    "BookMyShow": "bookmyshow",
    "BookStack": "bookstack",
    "Boost": "boost",
    "Boosty": "boosty",
    "Boots": "boots",
    "Bootstrap": "bootstrap",
    "BorgBackup": "borgbackup",
    "Bosch": "bosch",
    "Bose": "bose",
    "Botble CMS": "botblecms",
    "boulanger": "boulanger",
    "Bower": "bower",
    "Box": "box",
    "Boxy SVG": "boxysvg",
    "Braintree": "braintree",
    "Braintrust": "braintrust",
    "Brandfetch": "brandfetch",
    "Brandfolder": "brandfolder",
    "Brave": "brave",
    "Breaker": "breaker",
    "Brenntag": "brenntag",
    "Brevo": "brevo",
    "Brex": "brex",
    "Bricks": "bricks",
    "British Airways": "britishairways",
    "Broadcom": "broadcom",
    "Bruno": "bruno",
    "BSD": "bsd",
    "bspwm": "bspwm",
    "BT": "bt",
    "Buddy": "buddy",
    "Budibase": "budibase",
    "Buefy": "buefy",
    "Buffer": "buffer",
    "Bugatti": "bugatti",
    "Bugcrowd": "bugcrowd",
    "Buhl": "buhl",
    "Buildkite": "buildkite",
    "BuiltByBit": "builtbybit",
    "Bukalapak": "bukalapak",
    "Bulma": "bulma",
    "Bun": "bun",
    "Bungie": "bungie",
    "bunny.net": "bunnydotnet",
    "bunq": "bunq",
    "Burger King": "burgerking",
    "Burp Suite": "burpsuite",
    "Burton": "burton",
    "Buy Me A Coffee": "buymeacoffee",
    "BuySellAds": "buysellads",
    "BuzzFeed": "buzzfeed",
    "BVG": "bvg",
    "Byju's": "byjus",
    "ByteDance": "bytedance",
};
